<top-banner variant="title" [title]="selectedSite?.name"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-12">
            <h4 class="card-title">Schedule</h4>
            <div class="mb-2 animated fadeIn">
              <div class="d-flex justify-content-end">
                <button type="button" *ngIf="rejectedItems.length != 0" class="btn btn-primary btn-link" (click)="viewRejectedList()">view {{rejectedItems.length }} rejected items</button>
              </div>
              <scheduler-filters [initialDate]="initialDate" (filtersChanged)="onFiltersChanged($event)"></scheduler-filters>

              <div *ngIf="!response" style="width: 50px; margin: 0 auto">
                <p-progressSpinner [style]="{ width: '50px', height: '50px' }" [strokeWidth]="4"></p-progressSpinner>
              </div>

              <ng-container *ngIf="response">
                <scheduler
                    [hoursPerColumn]="hoursPerColumn"
                    [siteId]="response.id"
                    [assetsAndSchedules]="response.assets"
                    [start]="startTime"
                    [end]="endTime"
                    [isWorker]="true"
                    (gridClick)="onGridClick($event)"
                    (bookingClick)="onBookingClick($event)"
                ></scheduler>
                <br>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
